<template>
    <el-dialog
      :title="!configId ? '新增' : '修改'"
      width="95%"
      :close-on-click-modal='false'
      :append-to-body="true"
      :visible.sync='visible'
      :modal-append-to-body='false'
      @closed="reset"
    >
      <div class="mb-club trainVacate">
        <el-form ref="vocate" :model="vocate" class="unify-box vocate" label-width="auto" :inline-message="true" label-suffix=':'>
          <p class="title">请假设置</p>
          <el-row :gutter="24">
              <el-col :md="12" :sm="24">
                <el-form-item prop="trainType" label="培训类型">
                  <el-select v-model="vocate.trainType" placeholder='请选择' clearable size="mini" @change="trainType_select">
                    <el-option v-for="(item,index) in train_list" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12" :sm="24">
                <el-form-item label="是否允许请假">
                  <el-radio v-model="vocate.radio" label="0">否</el-radio>
                  <el-radio v-model="vocate.radio" label="1">是</el-radio>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row :gutter="24">
              <el-col :md="12" :sm="24">
                <el-form-item prop="deadline" label="训前请假截止">
                    <el-input v-model="vocate.deadline" size="mini" class="pay-inp" placeholder="请输入小时数" @input="vocate.deadline = vocate.deadline.replace(/[^\d]/g, '')"></el-input>小时
                    <el-tooltip effect="dark" content="表示距离培训开始前不能够再进行请假的小时数" placement="right">
                      <i class="icon el-icon-warning-outline"></i>
                    </el-tooltip>
                </el-form-item>
              </el-col>
          </el-row>
          <span class="verify">*</span>
        </el-form>
        <el-form ref="lesson_ticket" :model="lesson_ticket" :rules="lessonRules" class="unify-box" label-width="auto" :inline-message="true" label-suffix=':'>
          <p class="title">补课券设置</p>
          <el-row :gutter="24">
              <el-col :md="12" :sm="24">
                <el-form-item prop="lessonType" label="补课券类型">
                  <el-select v-model="lesson_ticket.lessonType" placeholder='请选择' clearable size="mini" @change="lesson_change">
                    <el-option label="分级整期培训" value="2" :disabled="!(vocate.trainType == 2)"></el-option>
                    <el-option label="青少年儿童培训" value="3" :disabled="!(vocate.trainType == 3)"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="12" :sm="24">
                <el-form-item prop="trainTypes" label="适用培训类型">
                  <el-checkbox-group v-model="lesson_ticket.trainTypes">
                    <el-checkbox :disabled="!(lesson_ticket.lessonType == 2)" label="2">分级整期培训</el-checkbox>
                    <el-checkbox :disabled="!(lesson_ticket.lessonType == 3)" label="3">青少年儿童培训</el-checkbox>
                    <el-checkbox :disabled="!(lesson_ticket.lessonType == 2)" label="1">分级单次培训</el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </el-col>
          </el-row>
          <el-row :gutter="24">
              <el-col :md="12" :sm="24">
                <el-form-item prop="maxNum" label="最多发放张数">
                    <el-input v-model="lesson_ticket.maxNum" size="mini" class="pay-inp" placeholder="请输入" @input="lesson_ticket.maxNum = lesson_ticket.maxNum.replace(/[^\d]/g, '')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" :sm="24">
                <el-form-item prop="validity" label="补课券有效期">
                    <el-input v-model="lesson_ticket.validity" size="mini" class="pay-inp" placeholder="请输入" @input="lesson_ticket.validity = lesson_ticket.validity.replace(/[^\d]/g, '')"></el-input>天
                </el-form-item>
              </el-col>
          </el-row>
        </el-form>
        <div class="btn-box">
          <el-button type="primary" plain @click="submit('edit')" v-if="configId">保存修改</el-button>
          <el-button type="primary" plain @click="submit('add')" v-else>确定</el-button>
          <el-button plain @click="cancel">取消</el-button>
        </div>
      </div>
    </el-dialog>
</template>
<script>
import { Trianset, ManagePartner } from '@/api/pages/train/trainVacate';
export default {
  data () {
    var maxNumRule = (rule, value, callback) => {
      let { lessonType } = this.lesson_ticket;
      if (value === '0') {
        callback(new Error('最多发放张数不能为0！'));
      } else if (lessonType == '2' && value > 1) {
        callback(new Error('分级整期培训最多可发放1张补课券！'));
      } else if (lessonType == '3' && value > 2) {
        callback(new Error('青少年儿童培训最多发放2张补课券！'));
      } else {
        callback();
      }
    };
    var validityRule = (rule, value, callback) => {
      if (value >= 1 && value <= 999) {
        callback();
      } else {
        callback(new Error('有效期范围为1-999天！'));
      }
    };
    return {
      configId: null,
      visible: false,
      train_list: [
        {
          label: '分级整期培训',
          value: '2'
        },
        {
          label: '青少年儿童培训',
          value: '3'
        },
        {
          label: '定制化个人培训-个人培训',
          value: '4'
        }
      ],
      lesson_list: [
        {
          label: '分级整期培训',
          value: '2'
        },
        {
          label: '青少年儿童培训',
          value: '3'
        }
      ],
      vocate: {
        trainType: null,
        radio: '0',
        deadline: null
      },
      lesson_ticket: {
        lessonType: null,
        trainTypes: [],
        maxNum: null,
        validity: null
      },
      lessonRules: {
        maxNum: [
          {
            validator: maxNumRule,
            trigger: 'blur'
          }
        ],
        validity: [
          {
            validator: validityRule,
            trigger: 'change'
          }
        ]
      }
    };
  },
  methods: {
    init (row) {
      this.visible = true;
      if (row) {
        let {
          configId,
          trianType,
          status,
          deadline,
          couponType,
          couponApplyType,
          trianCouponCount,
          validity
        } = row;
        this.configId = configId;
        this.vocate = {
          trainType: trianType,
          radio: status,
          deadline
        };
        this.lesson_ticket = {
          lessonType: couponType,
          trainTypes: couponApplyType.split(','),
          maxNum: trianCouponCount,
          validity
        };
      }
    },
    submit (type) {
      let { trainType, radio, deadline } = this.vocate;
      let { lessonType, trainTypes, maxNum, validity } = this.lesson_ticket;
      // 校验
      let tip_arr = [];
      let vocate_status = false;
      let lesson_ticket_status = false;
      if (trainType && deadline && radio) {
        vocate_status = true;
      } else {
        tip_arr.push('请假设置');
      }
      if (lessonType || trainTypes.length || maxNum || validity) {
        // 校验规则
        let valid_status = false;
        this.$refs.lesson_ticket.validate(valid => {
          if (valid) {
            valid_status = true;
          }
        });
        if (!valid_status) {
          return false;
        }
        // 校验填写是否完整
        if (lessonType && trainTypes.length && maxNum && validity) {
          lesson_ticket_status = true;
        } else {
          tip_arr.push('补课券设置');
        }
      }
      if (tip_arr.length > 0) {
        this.$confirm(`您${tip_arr.join('，')}中，信息未填写完整。`, '提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'warning'
        }).then(async () => {});
        return false;
      }
      // 校验完成，接口
      let data = {
        trianType: trainType,
        status: radio,
        deadline,
        couponType: lessonType,
        couponApplyType: trainTypes.join(),
        trianCouponCount: maxNum,
        validity
      };
      if (type === 'add') {
        Trianset(data).then(res => {
          if (res.code === 0) {
            this.$message.success(res.data);
            this.visible = false;
          }
          this.$emit('getDataList');
        });
      } else {
        data.configId = this.configId;
        let arr_tmp = [];
        arr_tmp.push(data);
        let data_edit = {
          flag: 1,
          data: arr_tmp
        };
        ManagePartner(data_edit).then(res => {
          if (res.code === 0) {
            this.$message.success(res.data);
            this.visible = false;
          }
          this.$emit('getDataList');
        });
      }
    },
    cancel () {
      this.visible = false;
    },
    reset () {
      this.configId = null;
      this.vocate = {
        trainType: null,
        radio: '0',
        deadline: null
      };
      this.lesson_ticket = {
        lessonType: null,
        trainTypes: [],
        maxNum: null,
        validity: null
      };
    },
    lesson_change (value) {
      this.$refs.lesson_ticket.validateField('maxNum', error => {});
      this.lesson_ticket.trainTypes = [];
    },
    trainType_select (value) {
      this.lesson_ticket.lessonType = null;
      this.lesson_ticket.trainTypes = [];
    }
  }
};
</script>
<style lang="scss" scoped>
.mb-club {
  overflow: auto;
  .unify-box {
    width: 68%;
    margin: 40px auto 0;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 10px 0 0 0;
    padding: 30px 40px 20px;
    position: relative;
    &:nth-child(2) {
      margin: 60px auto 0;
    }
    .title {
      width: 150px;
      font-size: 14px;
      text-align: center;
      background: #fff;
      position: absolute;
      top: -11px;
      left: 50px;
      letter-spacing: 1px;
      margin: 0; //去除默认属性影响
    }
    .gap {
      font-weight: bold;
      color: rgb(16, 16, 16);
      margin: 0 10px;
    }
    .number {
      width: 300px;
    }
    .label {
      font-size: 14px;
      font-weight: bold;
      color: #606266;
      margin-right: 12px;
    }
    .pay-inp {
      width: 200px;
      margin-right: 5px;
    }
    .gap-top {
      margin-top: 20px;
    }
  }
  .btn-box {
    width: 300px;
    display: flex;
    justify-content: space-between;
    margin: 40px auto 0;
    button {
      width: 124px;
    }
  }
}
</style>
<style lang="scss">
.mb-club.trainVacate {
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__label {
      font-weight: bold;
    }
  }
  .icon {
    font-size: 20px;
    margin-left: 5px;
    cursor: pointer;
  }
  .vocate {
    position: relative;
    .verify {
      position: absolute;
      color: red;
      top: 70px;
      left: -25px;
      font-size: 23px;
    }
  }
}
</style>
